import React from "react";
import { ProductDetailPageCarousel } from "./PDP_AccessoriesCarousel/ProductDetailPageCarousel";
import { PDPMainComponentProps } from "./PDPMainComponent";
import { renderNonEmpty } from "./renderNonEmpty";
import { usePdpTranslations } from "./PdpTranslationsContext";

export const PDPBelowTheFoldLayout_SpareParts: React.FC<
  React.PropsWithChildren<{
    data: PDPMainComponentProps["data"];
  }>
> = ({ data, children }) => {
  const t = usePdpTranslations();

  return (
    <>
      {renderNonEmpty(data.related.sparePartCompatibleProducts, products => (
        <ProductDetailPageCarousel
          headline={t("sparePartAlsoSuitableFor")}
          products={products}
          hidePrice={true}
          noLink={true}
        />
      ))}

      {children}
    </>
  );
};
